import React from "react";
import { Box, Grid } from "@mui/material";
import { Field } from "react-final-form";
import {
    renderInput,
    RenderSelect,
    RenderDatePicker,
} from "../../../Forms/FormFields";
import { RenderAutocompleteMultiple } from "../../../Forms/renderAutocompleteMultiple";
import {
    checkCommaAndBackSlashOnTags,
} from "../../../../lib/validationHelper";
import { createFilterOptions } from "@mui/material/Autocomplete";

const captureDataBoxStyle = {
    minWidth: ["100px"],
    width: "100%",
    overflow: "hidden",
};


const TrayFields = ({ form, trapTypeAutoCompleteOptions, loading, trapSites, trayId, tagsOptions, setHasValidationErrors }) => {

    return (
        <Box
            border="1px solid #ccc"
            borderRadius={1}
            style={captureDataBoxStyle}
            marginTop="10px"
        >
            <div
                className={"flex flex-1 flex-col p-2"}
                id={"trap-info"}
            >
                <div className={"flex flex-1 justify-around py-4 px-6"}>
                    <Grid container spacing={{ xs: 1, md: 3, lg: 5 }}>
                        <Grid item sm={6}>
                            <Box
                                className={"flex flex-1 flex-col"}
                                sx={{
                                    "& >div:first-of-type": {
                                        height: [
                                            "60px",
                                            "60px",
                                            "60px",
                                            "60px",
                                            "71px",
                                            "71px",
                                        ],
                                    },
                                    ".MuiAutocomplete-root + .MuiFormControl-root":
                                    {
                                        mt: [
                                            "0.5rem",
                                            "0.5rem",
                                            "0.5rem",
                                            "0.5rem",
                                            "1rem",
                                            "1rem",
                                        ],
                                    },
                                }}
                            >
                                <Field
                                    key="trapType"
                                    label="Collection Method"
                                    name="trapType"
                                    inputProps={{
                                        id: "trap-type-field",
                                        "data-testid": "collection-method",
                                    }}
                                    options={trapTypeAutoCompleteOptions || []}
                                    disabled={loading}
                                    component={RenderSelect}
                                    getOptionLabel={(value) => {
                                        return (
                                            trapTypeAutoCompleteOptions?.find(
                                                (option) => option?.id === value
                                            )?.displayName || ""
                                        );
                                    }}
                                    isOptionEqualToValue={(option, value) => {
                                        return option?.id === value;
                                    }}
                                    filterOptions={createFilterOptions({
                                        matchFrom: "any",
                                        stringify: (option) => option?.displayName,
                                    })}
                                />
                                <Field
                                    key="trapSiteId"
                                    data-testid="collection-site"
                                    id="Collection Site"
                                    label="Collection Site"
                                    name="trapSiteId"
                                    autocompleteProps={{
                                        id: "trap-site-field",
                                        // style: { width: "100%" },
                                    }}
                                    disabled={loading}
                                    options={trapSites || []}
                                    getOptionLabel={(value) => {
                                        return (
                                            trapSites?.find(
                                                (option) => option?.id === value
                                            )?.displayName || ""
                                        );
                                    }}
                                    isOptionEqualToValue={(option, value) => {
                                        return option?.id === value;
                                    }}
                                    getOptionKey={(option) => {
                                        return option?.id || "";
                                    }}
                                    filterOptions={createFilterOptions({
                                        matchFrom: "any",
                                        stringify: (option) => option.displayName,
                                    })}
                                    component={RenderSelect}
                                />
                            </Box>
                        </Grid>
                        <Grid item sm={6}>
                            <Box
                                className={"flex flex-1 flex-col"}
                                sx={{
                                    "& >div:first-of-type": {
                                        height: [
                                            "60px",
                                            "60px",
                                            "60px",
                                            "60px",
                                            "71px",
                                            "71px",
                                        ],
                                    },
                                    ".MuiFormControl-root + .MuiFormControl-root":
                                    {
                                        mt: [
                                            "0.5rem",
                                            "0.5rem",
                                            "0.5rem",
                                            "0.5rem",
                                            "1rem",
                                            "1rem",
                                        ],
                                    },
                                }}
                            >
                                <Field
                                    key="captureDate"
                                    label="Specimen Capture Date"
                                    name="captureDate"
                                    disabled={loading}
                                    component={RenderDatePicker}
                                    inputProps={{
                                        "data-testid": "capture-date",
                                    }}
                                    setHasErrorsFlag={setHasValidationErrors}
                                    cusMinDate="1900-01-01"
                                    trayId={trayId}
                                    handleChange={() => { }}
                                />
                                <Field
                                    key="notes"
                                    data-testid="notes"
                                    label="Notes"
                                    name="notes"
                                    inputProps={{
                                        id: "tray-notes",
                                        multiline: true,
                                        maxRows: 5,
                                        fullWidth: true,
                                    }}
                                    testId="notes"
                                    disabled={loading}
                                    handleChange={() => { }}
                                    component={renderInput}
                                />
                            </Box>
                        </Grid>
                        <Grid item sm={12} sx={{ marginTop: "-1rem" }}>
                            <Box
                                className={"flex flex-1 flex-col"}
                                sx={{
                                    ".MuiFormControl-root + .MuiFormControl-root":
                                    {
                                        mt: [
                                            "0.5rem",
                                            "0.5rem",
                                            "0.5rem",
                                            "0.5rem",
                                            "1rem",
                                            "1rem",
                                        ],
                                    },
                                }}
                            >
                                <Box
                                    sx={{
                                        border: "1px solid #ccc",
                                        borderRadius: 4,
                                        padding: "0.5px",
                                        mt: 2,
                                        textAlign: "center",
                                    }}
                                >
                                    <Field
                                        // multi
                                        label="Tray Tags"
                                        name={`tags`}
                                        chipColor="#ab47bc"
                                        shadowLabel={false}
                                        outlined={false}
                                        inputProps={{
                                            id: `tags`,
                                        }}
                                        component={RenderAutocompleteMultiple}
                                        // options={tagOptions || []}
                                        fieldValue={form?.values?.tags}
                                        onChange={(event, value) => {
                                            form.form.mutators.setValue("tags", [
                                                ...value,
                                            ]);
                                        }}
                                        options={tagsOptions}
                                        onBlur={(e) => e.preventDefault()}
                                        multiple={true}
                                        validate={checkCommaAndBackSlashOnTags}
                                        inputSX={{
                                            pl: ".5rem",
                                            "& .MuiFormLabel-root": {
                                                pl: "-2rem",
                                            },
                                        }}
                                    />
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </div>
            </div>
        </Box>
    )
}

export default TrayFields;